import script from "./MarketingContactTile.vue?vue&type=script&setup=true&lang=js"
export * from "./MarketingContactTile.vue?vue&type=script&setup=true&lang=js"

import "./MarketingContactTile.vue?vue&type=style&index=0&id=5ec11688&lang=scss"

const __exports__ = script;

export default __exports__